/*
 * fn: toggleColor
 *
 * Toggles a color in a list, keeping colorless exclusive and the rest in WUBRG order
 *
 * minColorId ensures every non-empty selection selects at least those colors
 *
 */
import { COLOR_ID_LABELS, type ColorIdType, COLORS, type ColorType } from '@/defs/mtg'

const COLORS_COLORED = COLORS.filter((c) => c !== 'c')

type Props = {
  color: ColorType
  colors: ColorType[]
  minColorId?: ColorIdType
}

export const toggleColor = ({ color, colors, minColorId }: Props): ColorType[] => {
  const minColors = minColorId ? COLORS_COLORED.filter((c) => COLOR_ID_LABELS[minColorId].colors.includes(c)) : []

  if (color !== 'c' && minColors.includes(color)) return colors.length > 0 ? [] : minColors
  if (color === 'c' && minColors.length > 0) return colors
  if (color === 'c') return colors.includes('c') ? [] : ['c']

  const colorsNew = new Set([...colors, ...minColors])
  if (colorsNew.has(color)) colorsNew.delete(color)
  else colorsNew.add(color)

  return COLORS_COLORED.filter((c) => colorsNew.has(c))
}
